import { makeStyles, Theme } from '@material-ui/core/styles';

export default makeStyles((theme: Theme) => ({
  formControlGroup: {
    display: 'block',
    flexWrap: 'wrap',
    flexDirection: 'column',
  },
  formControlErrors: {
    marginTop: '-0.35rem',
  },
  formControlCustom: {
    margin: 0,
    border: 0,
    display: 'inline',
    marginTop: '0.2rem',
    marginRight: '10px',
    padding: 0,
    position: 'relative',
    flexDirection: 'column',
    verticalAlign: 'top',
  },
  radioButtonField: {
    flexDirection: 'row',
    marginRight: theme.spacing(4),
  },
  formLabel: {
    transform: 'translate(0, 1.5px) scale(0.75)',
    transformOrigin: 'top left',
    top: 0,
    left: 0,
    position: 'absolute',
  },

  radioGroup: {
    marginTop: theme.spacing(1.5),
  },
}));
